/* ADD GROUPS */
export const LIST_QUIZZ = "LIST_QUIZZ"
export const LIST_QUIZZ_SUCCESS = "LIST_QUIZZ_SUCCESS"
export const LIST_QUIZZ_CLEAN = "LIST_QUIZZ_CLEAN"
export const LIST_QUIZZ_ERROR = "LIST_QUIZZ_ERROR"
